import React from "react";
import InfoItem from "../InfoItem/InfoItem";
import {checkEmptyObj, moveElementToEnd} from "helper/common";
import ArrayLabel from "../ArrayLabel/ArrayLabel";
import {Divider, Space} from "antd";

const Gonioscopy = props => {
  const {data, isShow = true} = props;
  const render = () => {
    return (
      <>
        {isShow && <div className="title">Soi góc tiền phòng:</div>}
        <Space direction="vertical">
          {moveElementToEnd(
            Object.keys(data || {}).filter(
              key =>
                data[key] &&
                key != "show" &&
                (data[key]?.select1 || data[key]?.select2 || data[key]?.select3)
            ),
            "Ghi chú"
          ).map(key => {
            return (
              <div>
                <span> • {key}: </span>
                {data[key]?.select1 ?? "--"} / {data[key]?.select2 ?? "--"} /{" "}
                {data[key]?.select3 ?? "--"}
              </div>
            );
          })}
          {data["Dưới"]?.Comments ? (
            <InfoItem label="Ghi chú" value={data["Dưới"]?.Comments}></InfoItem>
          ) : null}
        </Space>
        <Divider className="border-grey"></Divider>
      </>
    );
  };
  return <div className="Gonioscopy">{!checkEmptyObj(data) && render()}</div>;
};
export default Gonioscopy;
